import { render, staticRenderFns } from "./PrescriptionModelsList.vue?vue&type=template&id=6cc757d1&"
import script from "./PrescriptionModelsList.vue?vue&type=script&lang=js&"
export * from "./PrescriptionModelsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports